export default __webpack_public_path__ + "static/media/hospitality_2.e7a6bf7c.jpg";